import { FC } from "react";
import { Modal } from "@mui/material";
import { CircularProgress } from "../circularProgress";
import { styled } from "@mui/material/styles";

const StyledProgressWrapper = styled("div")({
  left: "50%",
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none",
});

const StyledModal = styled(Modal)(() => ({
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(255, 255, 255, 0.4)",
  },
}));

interface LoaderProps {
  isFullPage?: boolean;
}

const Loader: FC<LoaderProps> = ({ isFullPage = false }) => {
  const loader = (
    <StyledProgressWrapper
      role="presentation"
      tabIndex={0}
      aria-label="loading"
    >
      <CircularProgress thickness={2} size={75} />
    </StyledProgressWrapper>
  );
  return isFullPage ? <StyledModal open>{loader}</StyledModal> : loader;
};

export default Loader;
